import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { getConstructionApiUrl, formatDate } from '@common/utils';
import iso3166 from 'iso-3166-2';

export const compareAddresses = (project, newAddress) => {
  const cleanedAddress = {
    addressLine1: project.addressLine1 ? project.addressLine1 : '',
    addressLine2: project.addressLine2 ? project.addressLine2 : '',
    city: project.city ? project.city : '',
    stateOrProvince: project.stateOrProvince ? project.stateOrProvince : '',
    postalCode: project.postalCode ? project.postalCode : '',
    country: project.country ? project.country : '',
  };
  return (
    newAddress.addressLine1 === cleanedAddress.addressLine1 &&
    newAddress.addressLine2 === cleanedAddress.addressLine2 &&
    newAddress.city === cleanedAddress.city &&
    newAddress.stateOrProvince === cleanedAddress.stateOrProvince &&
    newAddress.zipostalCodep === cleanedAddress.postalCode &&
    newAddress.country === cleanedAddress.country
  );
};

export const compareDate = (newDate, originalDate) => {
  let newDateFormatted = newDate;
  if (newDateFormatted) {
    newDateFormatted = newDate.toISOString().slice(0, 10);
  }
  return newDateFormatted === originalDate;
};

export const isDuplicateNameError = (errors) => {
  const re = /^name:.+\sunique validation failed/i;

  return errors.some(
    (error) => error.field === 'name' && re.test(error.detail)
  );
};

export const buildGetProjectRequest = (
  projectId,
  useConstructionApi = false
) => {
  const url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();

  return `${url}/v1/projects/${projectId}`;
};

export const buildEditProjectRequest = (projectId, projectData) => [
  `${getAdminApiUrl()}/v1/projects/${projectId}`,
  {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(projectData),
  },
];

export const getProjectData = (state, additionalFieldsActivated) => ({
  name: state.projectName,
  type: state.selectedProjectType.value,
  addressLine1: state.address.addressLine1 || null,
  addressLine2: state.address.addressLine2 || null,
  city: state.address.city || null,
  stateOrProvince: state.address.stateOrProvince || null,
  postalCode: state.address.postalCode || null,
  country: state.address.country || null,
  startDate: state.startDate ? formatDate(state.startDate) : null,
  endDate: state.endDate ? formatDate(state.endDate) : null,
  ...(additionalFieldsActivated && {
    ...(state.jobNumber && { jobNumber: state.jobNumber }),
    ...{
      timezone: state.selectedTimeZone ? state.selectedTimeZone.value : null,
    },
    ...(state.projectValue && {
      projectValue: {
        value: parseFloat(state.projectValue),
        currency: state.selectedCurrency.value,
      },
    }),
  }),
});

export const validProjectValue = (value) => {
  const regInteger = /^\d+$/;

  return value !== '' ? regInteger.test(value) : true;
};

const getCountryStateNames = (countryCode, stateCode) => {
  let countryName = countryCode;
  let stateName = stateCode;
  const countryInfo = iso3166.data[countryCode];

  if (countryCode && countryCode !== '' && countryInfo) {
    countryName = countryInfo.name;
    const stateKey = `${countryCode}-${stateCode}`;
    if (stateCode && stateCode !== '' && countryInfo.sub[stateKey]) {
      stateName = countryInfo.sub[stateKey].name;
    }
  }

  return { countryName, stateName };
};

export const getInitialProjectAddress = ({
  addressLine1,
  city,
  stateOrProvince,
  postalCode,
  country,
}) => {
  let result = '';
  const addressLine1Empty = addressLine1 === '' || addressLine1 === null;
  const cityEmpty = city === '' || city === null;
  const stateOrProvinceEmpty =
    stateOrProvince === '' || stateOrProvince === null;
  const postalCodeEmpty = postalCode === '' || postalCode === null;
  const addressLineAndCityEmpty = addressLine1Empty && cityEmpty;
  const previousEmpty =
    addressLineAndCityEmpty && stateOrProvinceEmpty && postalCodeEmpty;
  const countryEmpty = country === '' || country === null;
  const { countryName, stateName } = getCountryStateNames(
    country,
    stateOrProvince
  );

  if (!addressLine1Empty) {
    result += addressLine1;
  }

  if (!cityEmpty) {
    result += (!addressLine1Empty ? ', ' : '') + city;
  }

  if (!stateOrProvinceEmpty) {
    result += (!addressLineAndCityEmpty ? ', ' : '') + stateName;
  }

  if (!postalCodeEmpty && stateOrProvinceEmpty) {
    result += (!addressLineAndCityEmpty ? ', ' : '') + postalCode;
  }

  if (!postalCodeEmpty && !stateOrProvinceEmpty) {
    result += ` ${postalCode}`;
  }

  if (!countryEmpty) {
    result += (!previousEmpty ? ', ' : '') + countryName;
  }
  return result;
};
